import { render, staticRenderFns } from "./DestinationOrderList.vue?vue&type=template&id=515ff7fe&scoped=true&"
import script from "./DestinationOrderList.vue?vue&type=script&lang=js&"
export * from "./DestinationOrderList.vue?vue&type=script&lang=js&"
import style0 from "./DestinationOrderList.vue?vue&type=style&index=0&id=515ff7fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515ff7fe",
  null
  
)

export default component.exports